import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

// Native modal semantics also isolate keyboard focus from the working panels.
export default function ProductionDialog({ label, className, onClose, children }) {
  const ref = useRef(null);
  useEffect(() => {
    const dialog = ref.current, previous = document.activeElement;
    if (dialog.showModal) dialog.showModal();
    return () => { if (dialog.open) dialog.close?.(); previous?.focus?.(); };
  }, []);
  return createPortal(<dialog ref={ref} open={typeof HTMLDialogElement === "undefined" || !HTMLDialogElement.prototype.showModal ? true : undefined} className={className} aria-label={label} onCancel={event => { event.preventDefault(); onClose(); }}>{children}</dialog>, document.body);
}
